import { createSlice, PayloadAction } from "@reduxjs/toolkit"

type NoteType = "person" | "project" | "placeholder"

type NoteState = {
  focusedNoteId: number | null
  noteType: NoteType | null
}

const initialState: NoteState = {
  focusedNoteId: null,
  noteType: null,
}

const noteSlice = createSlice({
  name: "note",
  initialState,
  reducers: {
    setFocusedNote: (
      state,
      action: PayloadAction<{
        noteId: number
        noteType: NoteType
      }>,
    ) => {
      state.focusedNoteId = action.payload.noteId
      state.noteType = action.payload.noteType
    },
    clearFocusedNote: (state) => {
      state.focusedNoteId = null
      state.noteType = null
    },
  },
})

export const { setFocusedNote, clearFocusedNote } = noteSlice.actions
export default noteSlice.reducer
